var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { Avatar } from "primereact/avatar";
import { OverlayPanel } from "primereact/overlaypanel";
import { useNavigate } from "react-router";
import ErrorBoundary from "../../ErrorBoundary";
import { useLogoutMutation } from "../../../features/auth/logout/services/logoutApi";
import { useToastContext } from "../../../contexts/toast-context";
import { getApiErrorMsg } from "../../../utils/api";
import { Endpoints } from "../../../routes";
import { useAppDispatch } from "../../../stores";
import { resetAuthSlice } from "../../../features/auth/authSlice";
import "./UserProfileMenu.css";
const UserProfileMenu = (props) => {
    const { email } = props;
    const overlayRef = useRef(null);
    const navigate = useNavigate();
    const { showToast } = useToastContext();
    const dispatch = useAppDispatch();
    const [logout, { isLoading: isLoggingOut }] = useLogoutMutation();
    const handleLogoutClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield logout(null).unwrap();
            dispatch(resetAuthSlice());
            navigate(Endpoints.ROOT);
        }
        catch (e) {
            showToast({
                severity: "error",
                summary: getApiErrorMsg(e)
            });
        }
    });
    return (_jsx(ErrorBoundary, { children: _jsxs("div", Object.assign({ className: "user-profile-menu" }, { children: [_jsx(Avatar, { className: "user-icon", onClick: e => { var _a; return (_a = overlayRef === null || overlayRef === void 0 ? void 0 : overlayRef.current) === null || _a === void 0 ? void 0 : _a.toggle(e); }, image: "/img/user_icon.png", shape: "circle", "data-testid": "userIcon" }), _jsx(OverlayPanel, Object.assign({ className: "user-profile-menu_overlay", ref: overlayRef }, { children: _jsxs("ul", Object.assign({ className: "user-profile_list" }, { children: [_jsxs("li", Object.assign({ className: "user-profile_list-item" }, { children: [_jsx("i", { className: "pi pi-user" }), "\u00A0", email] })), _jsxs("li", Object.assign({ className: "user-profile_list-item-button", onClick: handleLogoutClick, "data-testid": "logoutButton" }, { children: [_jsx("i", { className: isLoggingOut ? "pi pi-spin pi-spinner" : "pi pi-external-link" }), "\u00A0Logout"] }))] })) }))] })) }));
};
export default UserProfileMenu;
